import React from 'react';
import { DepotAddress } from '../../Models';
import './pickup-depot-address.component.scss';

interface PickUpDepotProps {
  Depot: DepotAddress;
}

export const PickupDepotAddress: React.FC<PickUpDepotProps> = ({ Depot }) => {
  return (
    <div className="pickup-address-component-container">
      <div className="pickup-address-container">
        <p className="my-1">
          {Depot.depotName}
          <br />
          {`${Depot.street ?? ''} ${Depot.houseNo ?? ''}`}
          <br />
          {`${Depot.zip ?? ''} ${Depot.city}`}
        </p>
        <table className="pickup-address-table">
          <tbody>
            <tr>
              <td>Montag</td>
              <td>08:00-12:00, 13:00-16:00</td>
            </tr>
            <tr>
              <td>Dienstag bis Freitag</td>
              <td>08:00-12:00, 13:00-18:00</td>
            </tr>
            <tr>
              <td>Samstag</td>
              <td>08:00-13:00</td>
            </tr>
            <tr>
              <td>Sonntag</td>
              <td>Geschlossen</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
